/* eslint-disable import/extensions */
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

import './assets/style/animate.css'
// @ts-ignore
import vueHeadful from 'vue-headful'
// @ts-ignore
import StarRating from 'vue-star-rating'
import vuetify from '@/plugins/vuetify'
// @ts-ignore
import VueLoading from 'vuejs-loading-plugin'
// @ts-ignore
import VueEllipseProgress from 'vue-ellipse-progress'
import customLoader from './components/core/CustomLoader.vue'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import registerComponents from './components'
import registerInterceptors from './interceptor'
import i18n from './i18n'
import store from './store'
import router from './router'
import AppModal from '@/components/core/AppModal.vue'
import Footer from '@/components/reading/content/Footer.vue'
import BookSidebar from '@/components/sidebar/BookSidebar.vue'
import PerfilSidebar from '@/components/sidebar/PerfilSidebar.vue'
import Modal from './plugins/modal'
import HighlightUtil from './plugins/HighlightUtil'
import { initPWA } from './utils/pwa'
import utils from './plugins/utils'

import App from './App.vue'

import './assets/style/app.scss'
import './assets/style/utils.scss'
import './assets/style/highlight.css'
import './assets/style/pwa.css'

// @ts-ignore
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
const wildcardTransition = createSimpleTransition('wildcard-transition')
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'


Vue.component('wildcard-transition', wildcardTransition)

registerComponents(Vue)
registerInterceptors()
// using default options
Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Cargando', // default 'Loading'
    loading: false, // default false
    customLoader, // replaces the spinner and text with your own
    background: 'rgba(104, 87, 178, 1)', // set custom background
})

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
    moment,
})
Vue.use(VueEllipseProgress)

Vue.component('vue-headful', vueHeadful)
Vue.config.productionTip = false

Vue.component('app-modal', AppModal)
Vue.component('star-rating', StarRating)
Vue.component('app-footer', Footer)
Vue.component('book-sidebar', BookSidebar)
Vue.component('perfil-sidebar', PerfilSidebar)
Vue.use(Modal)
Vue.use(HighlightUtil)
Vue.use(utils)

if (process.env.VUE_APP_ENV !== 'development') {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
    })
}
Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_ID,
    autoTracking: {
        screenview: true
    },
    debug: {
        sendHitTask: process.env.VUE_APP_ENV !== 'development'
    },
    router
})

Vue.config.devtools = process.env.VUE_APP_ENV === 'development'

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
}).$mount('#app')

// Inicializar PWA
initPWA()
